import { TrainingMembershipsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface TrainingMembershipsProps {
  trainingId: number
  ids?: number[]
  employeeId?: number
}

export const useTrainingMemberships = ({
  trainingId,
  ids,
  employeeId,
}: TrainingMembershipsProps) => {
  const { loading, data } = useQuery(TrainingMembershipsDocument, {
    variables: { trainingId, ids, employeeId },
  })

  return {
    loading,
    trainingMemberships: data ? data.trainings.trainingMembershipsConnection.nodes : [], // Provide a default value
  }
}
